/** One date for the three legal pages and the identity service's terms gate. Moving it
 * re-gates every existing user (spec §6.3). services/identity/src/identity/terms.py carries
 * the same value; test_identity_routes.py and the fake API pin it too. */
export const TERMS_VERSION = "2026-09-21";
export const BETA_NOTICE =
  "Beta — these terms are under review and will change before general availability.";
